/**
 * FilterComponent - Filter dropdowns for Course, Exam, and Subject
 */

import React, { useMemo } from 'react';
import { Select, Button } from 'antd';
import { getUniqueCourses, getUniqueSubjects } from '../helpers/questionFilter';

const { Option } = Select;

/**
 * FilterComponent - Displays filter dropdowns
 * @param {Object} props
 * @param {Array} props.exams - Array of all exam objects
 * @param {string|null} props.selectedCourse - Selected course ID
 * @param {string|null} props.selectedExam - Selected exam ID
 * @param {string|null} props.selectedSubject - Selected subject ID
 * @param {Function} props.onCourseChange - Callback when course changes
 * @param {Function} props.onExamChange - Callback when exam changes
 * @param {Function} props.onSubjectChange - Callback when subject changes
 * @param {Function} props.onClearFilters - Callback to clear all filters
 */
const FilterComponent = ({
    exams,
    selectedCourse,
    selectedExam, // Commented for future use - kept for prop compatibility
    selectedSubject,
    onCourseChange,
    onExamChange, // Commented for future use - kept for prop compatibility
    onSubjectChange,
    onClearFilters
}) => {
    // Get unique filter options
    const courses = getUniqueCourses(exams);
    const allSubjects = getUniqueSubjects(exams);
    
    // Get subjects based on selected course
    const availableSubjects = useMemo(() => {
        if (selectedCourse) {
            // If course is selected, get subjects for that course
            return allSubjects.filter(subject => subject.courseId === selectedCourse);
        }
        // No course selected, show all subjects
        return allSubjects;
    }, [selectedCourse, allSubjects]);
    
    const handleCourseChange = (value) => {
        onCourseChange(value);
        // If course is changed and subject is selected, clear subject if it doesn't belong to the new course
        if (value && selectedSubject) {
            const subject = allSubjects.find(sub => sub._id === selectedSubject);
            if (subject && subject.courseId !== value) {
                onSubjectChange(null);
            }
        }
    };

    return (
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <Select
                placeholder="Select Course"
                style={{ flex: 1, minWidth: 150 }}
                value={selectedCourse}
                onChange={handleCourseChange}
                allowClear
            >
                {courses.map((course) => (
                    <Option key={course._id} value={course._id}>
                        {course.name}
                    </Option>
                ))}
            </Select>

            {/* <Select
                placeholder="Select Exam"
                style={{ flex: 1, minWidth: 150 }}
                value={selectedExam}
                onChange={handleExamChange}
                allowClear
            >
                {examsList.map((exam) => (
                    <Option key={exam._id} value={exam._id}>
                        {exam.name}
                    </Option>
                ))}
            </Select> */}

            <Select
                placeholder="Select Subject"
                style={{ flex: 1, minWidth: 150 }}
                value={selectedSubject}
                onChange={onSubjectChange}
                allowClear
            >
                {availableSubjects.map((subject) => (
                    <Option key={subject._id} value={subject._id}>
                        {subject.name}
                    </Option>
                ))}
            </Select>
            
            <Button type="primary" onClick={onClearFilters}>Clear Filters</Button>
        </div>
    );
};

export default FilterComponent;

